module.exports = __webpack_public_path__ + "static/media/icon-piece4-3.0c2064d4.png";